import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import { forwardRef } from "react";
const SvgVi = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ jsxs("svg", { width: 19, height: 14, viewBox: "0 0 19 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx("path", { d: "M6.0344 11.0466L1.52886 6.69475L0 8.17145L6.0344 14L19 1.47671L17.4711 0L6.0344 11.0466Z", fill: "white" })
] });
const ForwardRef = forwardRef(SvgVi);
export default ForwardRef;
